import { MAX_CONCURRENT_SFX } from '@/lib/ai-assistant/editor/soundEffects';

// Shared <audio> tags the editor Player pre-mounts. Remotion's default is 5,
// and one more <Audio> mounted at once crashes the whole preview. Layouts in
// static-image mode premount the clip's audio for the scenes of the next 5 s,
// and audio layers add music plus up to MAX_CONCURRENT_SFX sound effects.
const PREMOUNTED_CLIP_AUDIO = 6;
const MUSIC_LAYERS = 2;
const HEADROOM = 2;

export const PREVIEW_SHARED_AUDIO_TAGS = PREMOUNTED_CLIP_AUDIO + MUSIC_LAYERS + MAX_CONCURRENT_SFX + HEADROOM;
